import Vue from 'vue';
import Vuex from 'vuex';
// import { CeremonyForm } from '@/models/CeremonyFormModel';
import UserStatus from '@/models/UserStatusModel';
import { EventInfoModel } from '@/models/EventFormModel';
import { Form } from '@/models/FormModel';

Vue.use(Vuex);
const getDefaultState = () => ({
  userStatus: new UserStatus(),
  form: new Form(), // memberForm
  homepageRoute: '/personalHomepage',
  eventInfo: {} as EventInfoModel,
  sidebarActive: true,
  overlayActive: false,
});
export default new Vuex.Store({
  state:
    getDefaultState(),

  mutations: {
    updateUserStatus(state, userStatus) {
      state.userStatus = userStatus;
    },

    updateCeremonyForm(state, ceremonyForm) {
      state.form.ceremonyForm = ceremonyForm;
    },

    updatePersonalInformation(state, object) {
      state.form.ceremonyForm.personalInformation = object;
    },
    updateLongevity(state, array) {
      state.form.ceremonyForm.longevityBoards = array;
    },
    updatePrayFor(state, array) {
      state.form.ceremonyForm.prayBoards = array;
    },
    updateAttendInfo(state, array) {
      state.form.ceremonyForm.attendInfoList = array;
    },

    updateLastEventSubmitted(state, isSubmitted) {
      state.form.isLastEventSubmitted = isSubmitted;
    },
    updateSubmitted(state, isSubmitted) {
      state.form.isSubmitted = isSubmitted;
    },
    updateStreamid(state, streamId) {
      state.form.streamId = streamId;
    },
    updateForm(state, form) {
      state.form = form;
    },

    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    updateEventInfo(state, object) {
      state.eventInfo = object;
    },

    updateSidebarActive(state, boolean) {
      state.sidebarActive = boolean;
    },
    updateOverlayActive(state, boolean) {
      state.overlayActive = boolean;
    },
  },
  actions: {
  },
  modules: {
  },
});
